// Shared loading skeletons (Session AAV, Loop 4): the one calm loading language across the
// office quoting surfaces. Quiet grey blocks on the dark elevation, always wrapped in an
// announced status region by the CALLER (the skeletons themselves are decorative).
// Session AGY: the bars animate with the shared .ele-shimmer sweep (src/index.css) instead of
// animate-pulse -- the themed shimmer pair reads on both grounds and honours reduced motion.
export function SkeletonPanel() {
  return (
    <div className="rounded-ele border border-ele-purple-accent bg-ele-surface p-5" aria-hidden>
      <div className="ele-shimmer h-4 w-40 rounded bg-ele-inset-strong" />
      <div className="mt-4 space-y-3">
        <div className="ele-shimmer h-3 w-full rounded bg-ele-inset-strong" />
        <div className="ele-shimmer h-3 w-3/4 rounded bg-ele-inset-strong" />
        <div className="ele-shimmer h-3 w-1/2 rounded bg-ele-inset-strong" />
      </div>
    </div>
  );
}

// A list/table placeholder: one bar per expected row.
export function SkeletonRows({ rows = 6 }: { rows?: number }) {
  return (
    <div className="space-y-2 rounded-ele border border-ele-purple-accent bg-ele-surface p-4" aria-hidden>
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="ele-shimmer h-8 rounded bg-ele-inset-strong" style={{ opacity: 1 - i * 0.09 }} />
      ))}
    </div>
  );
}
